import { createTheme, type ThemeOptions } from "@mui/material/styles";

export type AppThemeMode = "light" | "dark";

export const createAppTheme = (mode: AppThemeMode) => {
	const isDark = mode === "dark";
	const themeOptions: ThemeOptions = {
		palette: {
			mode,
			primary: { main: "#375dfb" },
			secondary: { main: "#0f766e" },
			success: { main: "#067647" },
			error: { main: "#b42318" },
			background: {
				default: isDark ? "#101828" : "#f5f7fb",
				paper: isDark ? "#182230" : "#ffffff"
			},
			text: {
				primary: isDark ? "#f8fafc" : "#182230",
				secondary: isDark ? "#a8b3c7" : "#667085"
			}
		},
		typography: {
			fontFamily:
				'Inter, ui-sans-serif, system-ui, -apple-system, "Segoe UI", sans-serif',
			h1: { fontWeight: 700, letterSpacing: "-0.04em" },
			h2: { fontWeight: 700, letterSpacing: "-0.02em" },
			h3: { fontWeight: 700 },
			h4: { fontWeight: 700 },
			h5: { fontWeight: 700 },
			h6: { fontWeight: 700 }
		},
		shape: {
			borderRadius: 12
		},
		components: {
			MuiCssBaseline: {
				styleOverrides: {
					body: {
						backgroundColor: isDark ? "#101828" : "#f5f7fb",
						color: isDark ? "#f8fafc" : "#182230"
					}
				}
			},
			MuiPaper: {
				styleOverrides: {
					root: {
						boxShadow: isDark
							? "none"
							: "0 8px 24px rgba(16,24,40,0.07)"
					}
				}
			},
			MuiCard: {
				styleOverrides: {
					root: {
						borderRadius: 12,
						boxShadow: isDark
							? "none"
							: "0 8px 24px rgba(16,24,40,0.07)"
					}
				}
			},
			MuiButton: {
				styleOverrides: {
					root: {
						textTransform: "none",
						fontWeight: 650,
						borderRadius: 8
					}
				}
			}
		}
	};

	return createTheme(themeOptions);
};

export default createAppTheme;
